import { saudiRiyalCurrencyImg } from "../constants";
import * as CURRENCY_SYMBOL_SIDE from "./currencySymbolSideConstants";

/**
 * @deprecated
 * @description Formatting a number to comma seperated!
 * @param {Number} number
 * @returns
 */

export const formatNumber = (number) => {
  let str = String(number);
  if (str !== "undefined" || str !== undefined) {
    return str
      .split("")
      .reduce(
        (a, b, i) => a + (i && !((str.length - i) % 3) ? "," : "") + b,
        ""
      );
  }
};

/**
 * @description dynamically format the currency amount
 * @param {Number} amount - amount received from the user, (which might from an api response)
 * @param {String} currencySymbolSide - `leftSpaceCode`,`leftCode`,`rightSpaceCode`,`rightCode`
 * @param {String} currencySymbol `$` etc.
 * @param {String} currencyCode `CAD`,`INR`,`USD` etc.
 * @param {Number} decimal `0`,`1`,`2` etc.
 * @example formatCurrency(123.22,'leftSpaceCode','$','USD',1)
 */
export const formatCurrency = (
  amount,
  currencySymbolSide,
  currencySymbol,
  currencyCode,
  decimal
) => {
  if (amount !== "undefined" || amount !== undefined) {
    const result = Number(amount).toLocaleString(undefined, {
      minimumFractionDigits: decimal ?? 0,
      maximumFractionDigits: decimal ?? 2,
    });
    if (
      currencySymbol === undefined ||
      currencySymbol === "undefined" ||
      currencyCode === undefined ||
      currencyCode === "undefined" ||
      decimal === undefined ||
      decimal === "undefined"
    ) {
      currencySymbol = "";
      currencyCode = "";
      decimal = 2;
    }

    if (currencyCode === "SAR") {
      currencySymbol = saudiRiyalCurrencyImg;
    }

    switch (currencySymbolSide) {
      case CURRENCY_SYMBOL_SIDE.LEFT_SPACE_CODE:
        return (
          <>
            <>{currencySymbol}</> {result}{/* {currencyCode} */}
          </>
        );
        return currencySymbol + " " + result + " " + currencyCode;
      case CURRENCY_SYMBOL_SIDE.RIGHT_SPACE_CODE:
        return (
          <>
            {result} <>{currencySymbol}</>{/* {currencyCode} */}
          </>
        );
        return result + " " + currencySymbol + " " + currencyCode;
      case CURRENCY_SYMBOL_SIDE.LEFT_CODE:
        return (
          <>
            <>{currencySymbol}</>
            {result}{/*  {currencyCode} */}
          </>
        );
        return currencySymbol + "" + result + " " + currencyCode;
      case CURRENCY_SYMBOL_SIDE.RIGHT_CODE:
        return (
          <>
            {result}
            <>{currencySymbol}</>{/*  {currencyCode} */}
          </>
        );
        return result + "" + currencySymbol + " " + currencyCode;
      case CURRENCY_SYMBOL_SIDE.LEFT_CODE_SYMBOL:
        return (
          <>
            <>{currencySymbol}</>
            {result}
          </>
        );
        return `${currencySymbol}${result}`;
      case CURRENCY_SYMBOL_SIDE.LEFT_CODE_SYMBOL_SPACE:
        return (
          <>
            <>{currencySymbol}</> {result}
          </>
        );
        return `${currencySymbol} ${result}`;
      case CURRENCY_SYMBOL_SIDE.LEFT_AMOUNT_CODE:
        return (
          <>
            {result}
            <>{currencySymbol}</>
          </>
        );
        return `${result}${currencySymbol}`;
      case CURRENCY_SYMBOL_SIDE.LEFT_AMOUNT_SPACE_CODE:
        return (
          <>
            {result} <>{currencySymbol}</>
          </>
        );
        return `${result} ${currencySymbol}`;
      case CURRENCY_SYMBOL_SIDE.CODE_AMOUNT_CODE:
        return (
          <>
            <>{currencySymbol}</> {result}{/*  {currencyCode} */}
          </>
        );
        return currencySymbol + " " + result + " " + currencyCode;
      default:
        break;
    }
  }
};

export const unmaskSSNNumber = (maskedNumber) => {
  return maskedNumber.replace(/\D+/g, "");
};
